import { color } from '@starryui10/theme/color';
import React from 'react';

export const Calendar = () => (
    <svg role="presentation" fill="none" xmlns="http://www.w3.org/2000/svg" height="96px" width="96px" viewBox="0 0 96 96">
        <circle cx="48" cy="48" r="48" fill={color.Grey.G10} />
        <g filter="url(#calendarGraphic_back)">
            <path
                d="M55.1555 31.2858L60.6356 30.31C61.6403 30.1311 62.6087 30.8068 62.7876 31.8114L68.6423 64.6923C68.8211 65.697 68.1455 66.6653 67.1408 66.8442L28.7798 73.6747C27.7751 73.8536 26.8068 73.1779 26.6279 72.1733L20.7732 39.2924C20.5943 38.2877 21.2699 37.3194 22.2746 37.1405L27.7548 36.1647"
                fill={color.Blue.B20}
            />
            <path
                d="M55.1555 31.2858L60.6356 30.31C61.6403 30.1311 62.6087 30.8068 62.7876 31.8114L68.6423 64.6923C68.8211 65.697 68.1455 66.6654 67.1408 66.8442L28.7798 73.6747C27.7751 73.8536 26.8068 73.1779 26.6279 72.1733L20.7732 39.2924C20.5943 38.2877 21.2699 37.3194 22.2746 37.1405L27.7548 36.1647"
                stroke={color.Blue.B60}
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M30.652 31.6932L31.9531 39L30.652 31.6932Z" fill={color.Blue.B20} />
            <path
                d="M30.652 31.6932L31.9531 39"
                stroke={color.Blue.B60}
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <g filter="url(#calendarGraphic_front)">
            <path
                d="M65.2066 26.8911H70.7729C71.7934 26.8911 72.6283 27.7261 72.6283 28.7466V62.1446C72.6283 63.1651 71.7934 64 70.7729 64H31.8086C30.7881 64 29.9531 63.1651 29.9531 62.1446V28.7466C29.9531 27.7261 30.7881 26.8911 31.8086 26.8911H37.3749"
                fill="white"
            />
            <path
                d="M65.2066 26.8911H70.7729C71.7934 26.8911 72.6283 27.7261 72.6283 28.7466V62.1446C72.6283 63.1651 71.7934 64 70.7729 64H31.8086C30.7881 64 29.9531 63.1651 29.9531 62.1446V28.7466C29.9531 27.7261 30.7881 26.8911 31.8086 26.8911H37.3749"
                stroke={color.Blue.B60}
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M40.9531 22.5782V30V22.5782Z" fill="white" />
            <path
                d="M40.9531 22.5782V30"
                stroke={color.Blue.B60}
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M61.9531 22.5782V30V22.5782Z" fill="white" />
            <path
                d="M61.9531 22.5782V30"
                stroke={color.Blue.B60}
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M49.9531 38H51.8086H49.9531Z" fill="white" />
            <path
                d="M49.9531 38H51.8086"
                stroke={color.Blue.B60}
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M59.9531 38H61.8086H59.9531Z" fill="white" />
            <path
                d="M59.9531 38H61.8086"
                stroke={color.Blue.B60}
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M40.9531 47H42.8086H40.9531Z" fill="white" />
            <path
                d="M40.9531 47H42.8086"
                stroke={color.Blue.B60}
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M49.9531 47H51.8086H49.9531Z" fill="white" />
            <path
                d="M49.9531 47H51.8086"
                stroke={color.Blue.B60}
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M59.9531 47H61.8086H59.9531Z" fill="white" />
            <path
                d="M59.9531 47H61.8086"
                stroke={color.Blue.B60}
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M40.9531 56H42.8086H40.9531Z" fill="white" />
            <path
                d="M40.9531 56H42.8086"
                stroke={color.Blue.B60}
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M49.9531 56H51.8086H49.9531Z" fill="white" />
            <path
                d="M49.9531 56H51.8086"
                stroke={color.Blue.B60}
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M44.9531 27H57.9412H44.9531Z" fill="white" />
            <path
                d="M44.9531 27H57.9412"
                stroke={color.Blue.B60}
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <filter
                id="calendarGraphic_back"
                x="14.7443"
                y="26.2811"
                width="59.9269"
                height="55.4225"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="2.5" />
                <feColorMatrix type="matrix" values="0 0 0 0 0.152941 0 0 0 0 0.156863 0 0 0 0 0.2 0 0 0 0.2 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
            </filter>
            <filter
                id="calendarGraphic_front"
                x="23.9531"
                y="18.5782"
                width="54.6752"
                height="53.4218"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="2.5" />
                <feColorMatrix type="matrix" values="0 0 0 0 0.152941 0 0 0 0 0.156863 0 0 0 0 0.2 0 0 0 0.2 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
            </filter>
        </defs>
    </svg>
);
